import { useState } from "react";
import "./Financování.css";
import { Helmet } from "react-helmet-async";
import { Button } from "@ceskastranaasocialu/komponenty";
import { ReactQRCode } from "@lglab/react-qr-code"
import LogoWhiteCropped from "../../images/logo-white-cropped.webp"
import financovaniTitle from "../../images/Titles/web_nadpis-financovani.webp"
import { Link } from "react-router-dom";


export default function Financovani() {
  const [currentMembershipPrice, setCurrentMembershipPrice] = useState(169);
  const [currentCustomMembershipPrice, setCurrentCustomMembershipPrice] = useState();

  const handleCustomPriceChange = (e) => {
    setCurrentCustomMembershipPrice(e.target.value);
    setCurrentMembershipPrice("custom");
  };

  const handleCustomPriceBlur = () => {
    const value = Number(currentCustomMembershipPrice);

    if (!value || value < 169) {
      setCurrentCustomMembershipPrice(169);
    } else if (value > 4999) {
      setCurrentCustomMembershipPrice(4999);
    } else {
      setCurrentCustomMembershipPrice(value);
    }
  };

  return (
    <div id="financovaniContent">
      <Helmet>
        <title>Financování · ČSA</title>
        <meta name="description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
        <meta property="og:title" content="Financování · ČSA" />
        <meta property="og:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
        <meta property="og:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
        <meta property="og:url" content="https://www.asocialove.cz/#/financovani" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Financování · ČSA" />
        <meta name="twitter:description" content="ČSA je recesistická politická strana, jejíž cílem, pokud ti to ještě nedošlo, je naprostá asocializace společnosti a České republiky. Chození ven způsobilo války, neštěstí a zmar, proto tu jsou asociálové, aby vše napravili. HLAVNĚ TO PROBOHA NEBERTE VÁŽNĚ, JSME RECESISTI!" />
        <meta name="twitter:image" content={`${process.env.PUBLIC_URL}/assets/banner.png`} />
      </Helmet>

      <div className="financovaniTitle">
        <img src={financovaniTitle} draggable="false" alt="" />
      </div>

      <div className="financovaniPruh financovaniPruhZelena">
        <p className="financovaniNadpis">Provozní účet</p>
        <p>Jak už z názvu vypovídá, tak z tohoto účtu provozujeme všechny platby, z jiného platit cokoli nemůžeme. Taky se na něj posílají členské příspěvky, to je celkem důležité říct.</p>
        <div className="financovaniButtony">
          <Button as="a" variant="dark" highlight href="https://www.csob.cz/firmy/bezne-ucty/transparentni-ucty/ucet?account=367611721" target="_blank" rel="noopener noreferrer">
            Odkaz na provozní účet
          </Button>
        </div>
      </div>

      <div className="financovaniPruh financovaniPruhRuzova">
        <p className="financovaniNadpis">Zvláštní účet</p>
        <p>Tento účet slouží hlavně na dary, což pokud byste nám chtěli přispět, prosím, nejprve vyplňte darovací smlouvu. Taky nám sem chodí příspěvky od státu (jen by to chtělo nějaké mít). Z něho nemůžeme platit nic.</p>
        <div className="financovaniButtony">
          <Button as="a" variant="dark" highlight href="https://www.csob.cz/firmy/bezne-ucty/transparentni-ucty/ucet?account=367617242" target="_blank" rel="noopener noreferrer">
            Odkaz na zvláštní účet
          </Button>
          <Link to="/pomoc?tab=donation"><Button variant="dark" highlight>Darovací smlouva</Button></Link>
          </div>
      </div>

      <div className="financovaniPruh financovaniPruhZelena">
        <p className="financovaniNadpis">Mzdový účet</p>
        <p>Tento účet je pro zaměstnance. Máme přesně 0 (slovy nula) zaměstnanců. Proč ho tedy máme? Musíme.</p>
        <div className="financovaniButtony">
          <Button as="a" variant="dark" highlight href="https://www.csob.cz/firmy/bezne-ucty/transparentni-ucty/ucet?account=367616506" target="_blank" rel="noopener noreferrer">
            Odkaz na mzdový účet
          </Button>
        </div>
      </div>

      <div className="financovaniPruh financovaniPruhRuzova">
        <p className="financovaniNadpis">Pro členstvo</p>
        <div className="financovaniClenstvoWrapper">
          <div className="financovaniClenstvoText">
            <p>Členské příspěvky se posílají na provozní účet. Do poznámky je třeba napsat „Členský příspěvek". Minimální výše je 169Kč, maximální je 4999Kč. Pro poslání příspěvku můžete využít QR kód nebo číslo účtu (367611721/0300).</p>
            <p>Pokud si toto čte někdo, kdo není ze strany, tak na tento účet NEPOSÍLEJ peníze, na to využij darovací smlouvu.</p>
          </div>

          <div className="financovaniTabulka">
            <table>
              <tbody>
                <tr>
                  <th>částka</th>
                  <td>
                    <Button variant={currentMembershipPrice === 169 ? "primary" : "ghost"} highlight onClick={() => setCurrentMembershipPrice(169)}>169 Kč</Button>
                    <Button variant={currentMembershipPrice === 420 ? "primary" : "ghost"} highlight onClick={() => setCurrentMembershipPrice(420)}>420 Kč</Button>
                    <Button variant={currentMembershipPrice === 1000 ? "primary" : "ghost"} highlight onClick={() => setCurrentMembershipPrice(1000)}>1000 Kč</Button>
                    <Button variant={currentMembershipPrice === "custom" ? "primary" : "ghost"} highlight onClick={() => setCurrentMembershipPrice("custom")}>
                      <input
                          type="number"
                          min={169}
                          max={4999}
                          step={1}
                          placeholder="???"
                          value={currentCustomMembershipPrice}
                          onChange={handleCustomPriceChange}
                          onBlur={handleCustomPriceBlur}
                          onClick={(e) => e.stopPropagation()}
                          onKeyDown={(e) => e.stopPropagation()}
                      />
                      Kč
                    </Button>
                  </td>
                  <td className="qrBunka" rowSpan={3}>
                    <ReactQRCode value={`SPD*1.0*ACC:CZ4503000000000367611721*DT:20260927*AM:${currentMembershipPrice === "custom" ? (currentCustomMembershipPrice || 169) : currentMembershipPrice}*CC:CZK*MSG:Členský příspěvek`} svgProps={{class: "QR"}} size={500} marginSize={3} dataModulesSettings={{color: "#f0f0f0"}} finderPatternInnerSettings={{color: "#f0f0f0"}} finderPatternOuterSettings={{color: "#f0f0f0"}} level="L" />
                  </td>
                </tr>
                <tr>
                  <th>účet</th>
                  <td>367611721/0300</td>
                </tr>
                <tr>
                  <th>popis</th>
                  <td>členský příspěvek</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
